import { Injectable } from "@angular/core";
import { doc, docData, DocumentReference, Firestore } from "@angular/fire/firestore";
import { firstValueFrom, from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { ProfileStateDispatcher } from "../../../core/state/profile/profile.dispatcher";
import { environment } from "../../../../environments/environment";
import { IUserSubscription } from "@soposopo/sopo-models";
import { ApiService } from "../../../core/backend/api.service";

@Injectable({providedIn: 'root'})
export class SubscriptionHandlerService {
    subscribed: boolean = false;
    subscriptionId: string;

    constructor (
        private profileService: ProfileStateDispatcher,
        private firestore: Firestore,
        private apiService: ApiService
    ) {}

    public async initStore() {
        if (environment.staging === false) return;
    }

    async subscribe() {
        
        if (environment.staging) return this.bypassiap();

       throw Error('Subscription is not yet available on desktop. Please use your Android or iOS device to subscribe!');
    }

    async bypassiap() {
        const userId = await this.profileService.getMyID();
        await this.apiService.bypassSubscription(userId);
        return true;
    }

    public get mySubscription$() {
        return from(this.profileService.getMyID()).pipe(
            switchMap(userId => {
                const docReference = doc(this.firestore, `users/${userId}/subscriptions/sopoPlus`) as DocumentReference<IUserSubscription>;
                return docData(docReference);
            })
        );
    }

    public get mySubscription() {
        return firstValueFrom(this.mySubscription$);
    }

    getPrice() {
        if (environment.staging) return 'TEST $$';
        return '$0.99'
    }
}
